import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../constants/index";
import { Dropdown } from "semantic-ui-react";

const Language = () => {
  const [, i18n] = useTranslation("global");
  
  const onChangeLang = (e) => {
    const imgElement = e.target.querySelector('img');
    let imgSrc = "";
    if (imgElement) {
      imgSrc = imgElement.getAttribute('src');
    }
    if (
      e.target.src ===
      "https://img.favpng.com/3/5/21/flag-of-the-united-kingdom-flag-of-great-britain-flag-of-england-png-favpng-q7ZWJzpaYN34ZfrVGRepJsUKN_t.jpg" ||
      imgSrc === "https://img.favpng.com/3/5/21/flag-of-the-united-kingdom-flag-of-great-britain-flag-of-england-png-favpng-q7ZWJzpaYN34ZfrVGRepJsUKN_t.jpg"
    ) {
      i18n.changeLanguage("en");

    } else {
      i18n.changeLanguage("de");
    }
  };


  return (
    <span className="z-10 ">
      <Dropdown
        inline
        options={LANGUAGES}
        defaultValue={i18n.language}
        onChange={onChangeLang}
        className="!flex !items-center !h-[50px] pl-4"
        style={{ width: "200px", height: "50px" }}
      />
    </span>
  );
};

export default Language;
